module.exports = __webpack_public_path__ + "img/23_6.2c641f04.png";